export default __webpack_public_path__ + "static/media/seven.1782fef0.png";